import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function MarketingExplist() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/departments">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Sales and Marketing
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Product Brochure Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/chatbot2.png"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/marketing-chatbot">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className="exp">
              <h2>
                Marketing Brochure Chatbot <br /> using Prompt Engineering
              </h2>
              <img className="exp-img" src="./assets/images/Designer.png" />
              <Link to="/marketing-prompt-engineering">
                <p>Open</p>
              </Link>
            </div> */}

            <div className="exp">
              <h2>Faq Generator</h2>
              <img
                className="exp-img"
                src="/assets/images/faq2.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/faq-generator">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp" style={{ padding: "1rem 1rem" }}>
              <h2>Product Description Generator</h2>
              <img
                className="exp-img"
                src="/assets/images/productdesc.png"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/prod-desc">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className='exp'>
          <h2>Data Analytics</h2>
          <Link to="/data-analytics"><p>Open</p></Link>
        </div> */}
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Image Generator</h2>
              <img
                className="exp-img"
                src="/assets/images/image generator.png"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/marketing-image-generator">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Sales Negotiation</h2>
              <img
                className="exp-img"
                src="/assets/images/sales.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/sales-negotiation">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp" style={{ padding: "1rem 0.5rem" }}>
              <h2>Marketing Brochure Comparison</h2>
              <img
                className="exp-img"
                src="/assets/images/marketing1.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/marketing-comparison">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>
                Prompt Engineering using <br /> marketing
              </h2>
              <img
                className="exp-img"
                src="/assets/images/resume.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/prompt-eng-marketing">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className="exp" style={{ padding: "1rem 2rem" }}>
              <h2>Course Recommendation</h2>
              <img className="exp-img" src="./assets/images/course.jpg" />
              <Link to="/course-recommendation">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp" style={{ padding: "1rem 2.5rem" }}>
              <h2>Sentiment Analysis</h2>
              <img className="exp-img" src="./assets/images/sentiment.jpg" />
              <Link to="/sentiment-analysis">
                <p>Open</p>
              </Link>
            </div> */}
          </div>
          {/* <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp" style={{padding : "1rem 1rem"}}>
              <h2>IT-OT</h2>
              <img className="exp-img" src="./assets/images/resume.jpg" />
              <Link to="/pharma-it-ot">
                <p>Open</p>
              </Link>
            </div>
          </div> */}
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
